import { render, staticRenderFns } from "./UserViewsImport.vue?vue&type=template&id=50c53360"
import script from "./UserViewsImport.vue?vue&type=script&lang=ts"
export * from "./UserViewsImport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c53360')) {
      api.createRecord('50c53360', component.options)
    } else {
      api.reload('50c53360', component.options)
    }
    module.hot.accept("./UserViewsImport.vue?vue&type=template&id=50c53360", function () {
      api.rerender('50c53360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/UserViewsImport.vue"
export default component.exports